import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './firebase/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import Start from './components/Start';
import Login from './components/Login';
import Regist from './components/Regist';
import ProfileSetup from './components/ProfileSetup';
import EmailVerification from './components/EmailVerification';
import EmailVerificationComplete from './components/EmailVerificationComplete';
import ForgotPassword from './components/ForgotPassword';
import PasswordReset from './components/PasswordReset';
import Top from './components/Top';
import PosterCreate from './components/PosterCreate';
import PosterDetail from './components/PosterDetail';
import PosterList from './components/PosterList';
import PaymentSuccess from './components/PaymentSuccess';
import CommentSummary from './components/CommentSummary';
import MantraAdmin from './components/MantraAdmin';
import TopicTagsAggregate from './components/TopicTagsAggregate';
import CommunitySummary from './components/CommunitySummary';
import Footer from './components/Footer';
import ScrollToTopOnNavigate from './components/ScrollToTopOnNavigate';
import './App.css';

// 環境変数でMantraAdminを制御（本番環境では非表示）
// 開発環境で使用する場合は、.envファイルに REACT_APP_ENABLE_MANTRA_ADMIN=true を設定
const enableMantraAdmin = process.env.REACT_APP_ENABLE_MANTRA_ADMIN === 'true';

function App() {
  return (
    <AuthProvider>
      <Router>
        <ScrollToTopOnNavigate />
        <div className="App">
          <Routes>
            {/* 公開ポータル（未ログインでも閲覧可） */}
            <Route path="/" element={<CommunitySummary />} />
            <Route path="/start" element={<Start />} />
            <Route path="/login" element={<Login />} />
            <Route path="/regist" element={<Regist />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/password-reset" element={<PasswordReset />} />
            <Route path="/email-verification" element={<EmailVerification />} />
            <Route path="/email-verification-complete" element={<EmailVerificationComplete />} />
            <Route path="/profile-setup" element={
              <ProtectedRoute>
                <ProfileSetup />
              </ProtectedRoute>
            } />
            <Route path="/top" element={
              <ProtectedRoute>
                <Top />
              </ProtectedRoute>
            } />
            <Route path="/poster-create" element={
              <ProtectedRoute>
                <PosterCreate />
              </ProtectedRoute>
            } />
            <Route path="/poster-detail" element={
              <ProtectedRoute>
                <PosterDetail />
              </ProtectedRoute>
            } />
            <Route path="/list" element={
              <ProtectedRoute>
                <PosterList />
              </ProtectedRoute>
            } />
            <Route path="/poster-list" element={
              <ProtectedRoute>
                <PosterList />
              </ProtectedRoute>
            } />
            <Route path="/payment-success" element={
              <ProtectedRoute>
                <PaymentSuccess />
              </ProtectedRoute>
            } />
            <Route path="/poster-summary" element={
              <ProtectedRoute>
                <Navigate to="/comment-summary" replace />
              </ProtectedRoute>
            } />
            <Route path="/comment-summary" element={
              <ProtectedRoute>
                <CommentSummary />
              </ProtectedRoute>
            } />
            {/* MantraAdminは環境変数で制御（本番環境では非表示） */}
            {enableMantraAdmin && (
              <>
                <Route path="/mantra-admin" element={
                  <ProtectedRoute>
                    <MantraAdmin />
                  </ProtectedRoute>
                } />
                <Route path="/topic-tags-aggregate" element={
                  <ProtectedRoute>
                    <TopicTagsAggregate />
                  </ProtectedRoute>
                } />
              </>
            )}
            {/* 404エラー時は/に戻す */}
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
          <Footer />
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App;
